/**
 * @desc 批量箱子绑定交货单
 */
const URL = "/rantion-srm";
import http, { updateResponse } from "@/http";
export function request(body: defs.srm.SupplierBatchDonoBindBoxRequestDto, options?: any) {
  return updateResponse(
    http(URL + `/srm/supplierBox/donoBatchBox`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
